import React, { useContext } from 'react';
import styled from 'styled-components';
import styles from '@rsc/ui-components/styles';
import { CartContext } from '@rsc/contexts/CartContext';
import { MdOutlineShoppingCart } from 'react-icons/md';
import { useUiComponentsInternationalContext } from '@rsc/static-translations';
import { LocalizedLink } from '@rsc/gatsby-localization-helpers';

const CartLink = styled(LocalizedLink)`
  cursor: pointer;
  display: flex;
  position: relative;
  height: ${styles.spacing['spacing-1xl']};
  width: ${styles.spacing['spacing-1xl']};
  border-radius: ${styles.spacing['spacing-2xs']};
  margin-left: ${styles.spacing['spacing-2xs']};

  &:hover {
    background: ${({ theme }) => theme.colors.iconButtonBackgroundHover};
  }
`;

const Icon = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    transition: all 0.5s ease;
    fill: ${({ theme }) => theme.colors.iconButtonFill};
  }

  &:hover {
    svg {
      fill: ${({ theme }) => theme.colors.iconButtonFill};
    }
  }
`;

const CartCount = styled.div`
  position: absolute;
  display: flex;
  color: ${({ theme }) => theme.colors.badgeText};
  background: ${({ theme }) => theme.colors.badge};
  font-size: 0.625rem;
  border-radius: 50%;
  width: 17px;
  height: 17px;
  align-items: center;
  justify-content: center;
  right: -2px;
  top: -2px;
  font-weight: normal;
`;

function CartIcon() {
  const { cart, cartActive, setCartActive } = useContext(CartContext);
  const { tt } = useUiComponentsInternationalContext();

  return (
    <CartLink
      title={tt(s => s.headerCommon.cartIconTitle)}
      aria-label={tt(s => s.headerCommon.cartAriaLabel)}
      to="/"
      onClick={e => {
        e.preventDefault();
        setCartActive(!cartActive);
      }}
    >
      <Icon>
        <MdOutlineShoppingCart size={28} />
      </Icon>
      <span className="sr-only">Cart:</span>
      {cart?.totalQuantity > 0 ? (
        <CartCount>
          {cart.totalQuantity}
          <span className="sr-only">
            {cart.totalQuantity === 1 ? `item` : `items`}
          </span>
        </CartCount>
      ) : (
        <span className="sr-only">0 items</span>
      )}
    </CartLink>
  );
}

export default CartIcon;
